import { Link, Typography } from "@mui/material";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Onboarding.Steps.PersonalInformation.ThanksToYouParticipation;

/**
 * Label of the Díky Tobě consent checkbox in the registration wizard (ZS-1623). Links the program
 * terms PDF — the same one the program section links.
 */
export const ThanksToYouParticipationCheckboxLabel = () => {
  const { t } = useResource();
  const termsUrl = t(
    Resources.Components.Affiliate.UserAffiliate.TermsLinkUrl,
    {
      apiUrl: getApiUrl(),
    },
  );

  return (
    <Typography>
      {t(COMPONENT_RESOURCES.Text)}
      <Link target="_blank" rel="noopener noreferrer" href={termsUrl} mx={1}>
        {t(COMPONENT_RESOURCES.LinkText)}
      </Link>
    </Typography>
  );
};
